export default class Message{

    static sendMessage(message, spread_id, issue_id = false) {
        if (typeof message === 'string') {
            message = Message.createMessage(message);
        }

        //add spread_id to the message so the frontend can easily find the frame where its comming from
        message.origin_spread_id = spread_id;

        if(issue_id){
            message.origin_issue_id = issue_id;
        }

        let targetWindow = window;
        if(window.frontend === undefined){
            targetWindow = window.parent;
        }

        targetWindow.postMessage(message, '*');

        console.debug(message);
    }

    /**
     * Create an object containing the message property
     * @method createMessage
     * @param {String} body
     * @returns {{message: *}}
     */
    static createMessage(body) {
        return {message: body};
    }

    /**
     * Send a message to the parent window that is embedding the current page.
     *
     * @param {object|string} message
     * @param {{}} data
     */
    static sendEmbedMessage(message, data = {} ){
        if (typeof message === 'string') {
            message = Message.createMessage(message);
        }
        message.data = data;
        message.embedId = window.maglrEmbedId;

        //add origin_spread_id to the message so the legacy mode won't be triggered in the frontend.
        message.origin_spread_id = "sendEmbedMessage";// value for origin_spread_id can be anything.

        window.parent.postMessage(message, '*');
    }

}

